// Start here's list of screens (live's sidebar inside the course): "<n> of 19 screens done" with its
// bar, then each row ("Section 1, Deal analysis") and its screens, each marked done, the one they're
// on, open, or locked until the screens before it are done. On a laptop it sits beside the screen;
// narrower, it folds above the screen behind "All screens", as PhoneWeek.dc.html puts the weeks above
// the page.
import { useState } from 'react'
import { Link } from '../../../lib/router.jsx'
import { LockLine, Tick } from '../../../product/Icons.jsx'
import { COPY } from './copy.js'
import { screenHref } from './model.js'

export function Rail({ product, model, entry }) {
  const [open, setOpen] = useState(false)
  const pct = model.total ? Math.round((model.doneCount / model.total) * 100) : 0
  return (
    <nav className={open ? 'ps-rail ps-rail--open' : 'ps-rail'} aria-label={COPY.railTitle}>
      <div className="ps-rail-head">
        <p className="ps-rail-title">{COPY.railTitle}</p>
        <p className="ps-rail-count">{COPY.screensDone(model.doneCount, model.total)}</p>
        <span className="ps-rail-bar" aria-hidden="true"><span style={{ width: `${pct}%` }} /></span>
        <button type="button" className="ps-rail-toggle" aria-expanded={open} aria-controls="ps-rail-list" onClick={() => setOpen(!open)}>
          {open ? COPY.hideScreens : COPY.allScreens}
        </button>
      </div>
      <div className="ps-rail-list" id="ps-rail-list">
        {model.groups.map(({ row, screens }) => (
          <div className="ps-rail-group" key={row.id}>
            <p className="ps-rail-group-h">{COPY.eyebrow(row.config?.label, row.title)}</p>
            <ol>
              {screens.map(s => {
                const at = model.order.find(o => o.screen.id === s.id)
                const done = model.isDone(s)
                const here = entry && entry.screen.id === s.id
                const reachable = model.isOpen(at)
                const state = !reachable ? 'locked' : done ? 'done' : 'open'
                const mark = (
                  <span className={`ps-rail-dot ps-rail-dot--${state}${here && reachable ? ' ps-rail-dot--here' : ''}`} aria-hidden="true">
                    {done ? <Tick size={11} stroke={3.2} /> : state === 'locked' ? <LockLine size={12} /> : null}
                  </span>
                )
                return (
                  <li key={s.id}>
                    {reachable
                      ? (
                        <Link className={`ps-rail-item ps-rail-item--${state}${here ? ' ps-rail-item--here' : ''}`} to={screenHref(product, row, s)} aria-current={here ? 'page' : undefined}
                          onClick={() => setOpen(false)}>
                          {mark}<span className="ps-rail-text">{s.title}</span>
                          {done && <span className="sr-only">, {COPY.doneWord}</span>}
                        </Link>
                      )
                      : (
                        <span className={`ps-rail-item ps-rail-item--locked${here ? ' ps-rail-item--here' : ''}`} aria-disabled="true">
                          {mark}<span className="ps-rail-text">{s.title}</span><span className="sr-only">, {COPY.lockedWord}</span>
                        </span>
                      )}
                  </li>
                )
              })}
            </ol>
          </div>
        ))}
      </div>
    </nav>
  )
}
